import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './popup.css'; // We'll create this CSS file

const Popup = () => {
  const [showPopup, setShowPopup] = useState(true);
  const navigate = useNavigate();

  // Show popup on page refresh
  useEffect(() => {
    const popupShown = localStorage.getItem('popupShown');
    if (!popupShown) {
      setShowPopup(true);
      localStorage.setItem('popupShown', 'true');
    }
  }, []);

  const handleRegister = () => {
    navigate('/visual-impaired-registration');
    setShowPopup(false);
  };

  const handleHomeClick = () => {
    setShowPopup(true);
  };

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="close-button" onClick={() => setShowPopup(false)}>
          ×
        </button>
        
        <div className="blinking-text">REGISTRATION</div>
                  <p className="early-bird-para">
          Registering visually impaired individuals to connect them with better care, support, and opportunities          </p>
        <div className="popup-content">
 
          <p>
               Every life deserves clear pathways.
We’re enrolling visually impaired individuals
to provide better healthcare, stronger support, and new opportunities.
          </p>
          
          {/* <div className="popup-image-container">
            <img 
              src="/round-logo.png" 
              alt="Enroll Now" 
              className="popup-image"
            />
          </div> */}
          
          <ul className="program-list">
   
               <li>
              <strong>Organised by:</strong> Community Eye Care Services
            </li>
          </ul>
          

          
          <button className="register-button" onClick={handleRegister}>
            Register Now
          </button>



        </div>
      </div>
    </div>
  );
};

export default Popup;